import { Result } from '~~/core/helpers/result';
import type { AuthRepository } from '~~/core/ports/repositories/AuthRepository';

export const nuxtAuthRepository: AuthRepository = {
	async phone({ phoneNumber }) {
		try {
			const response = await $fetch('/api/auth/phone', {
				method: 'POST',
				body: { phoneNumber }
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while sending the phone number for OTP verification.',
				source: 'nuxtAuthRepository.phone',
				originalErrorObject: error as Error
			});
		}
	},
	async getCreatePhoneUser(params) {
		try {
			const response = await $fetch('/api/auth/get-create-phone-user', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while sending the phone number for OTP verification.',
				source: 'nuxtAuthRepository.getCreatePhoneUser',
				originalErrorObject: error as Error
			});
		}
	},
	async completeSocialRegistration(params) {
		try {
			const response = await $fetch('/api/auth/complete-social-registration', {
				method: 'POST',
				body: params
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying to complete social registration.',
				source: 'nuxtAuthRepository.completeSocialRegistration',
				originalErrorObject: error as Error
			});
		}
	},
	async completePhoneRegistration(params) {
		try {
			const response = await $fetch('/api/auth/complete-phone-registration', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying to complete phone registration.',
				source: 'nuxtAuthRepository.completePhoneRegistration',
				originalErrorObject: error as Error
			});
		}
	},
	async verifySocialRegistration(params) {
		try {
			const response = await $fetch('/api/auth/verify-social-registration', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying verify OTP for social registration.',
				source: 'nuxtAuthRepository.verifySocialRegistration',
				originalErrorObject: error as Error
			});
		}
	}
};
